import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getAction } from '@/api/manage';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import moment, { months } from 'moment';
import waterRadarChart from '@/components/biChart/waterRadarChart';
import yearRange from '@/components/date/yearRange';
import weekRange from '@/components/date/weekRange';
import colControl from '@/components/colControl/colControl';
export default {
  name: 'radarAnalysis',
  mixins: [GetSiteIdMixin],
  components: {
    waterRadarChart: waterRadarChart,
    yearRange: yearRange,
    weekRange: weekRange,
    colControl: colControl
  },
  data: function data() {
    return {
      colOptions: [],
      initNum: 0,
      value: ['2'],
      reportType: '11',
      limitSelectDate: {},
      stime: '',
      etime: '',
      dateFormat: 'YYYY-MM-DD',
      chartBoxHeight: '604px',
      tableData: [],
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 8
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      }
    };
  },
  created: function created() {
    this.limitSelectDate = {
      min: moment().startOf('day').subtract(1, 'week'),
      max: moment().endOf('day')
    };
    this.value[0] = this.limitSelectDate.min;
    this.value[1] = this.limitSelectDate.max;
    this.stime = this.limitSelectDate.min.format('YYYY-MM-DD');
    this.etime = this.limitSelectDate.max.format('YYYY-MM-DD');
  },
  watch: {
    currentSiteId: function currentSiteId(value) {}
  },
  methods: {
    onChange: function onChange() {
      var datas = JSON.parse(JSON.stringify(this.$refs.charts.selectedData));
      var codeObj = datas.codeObj;
      console.log('datas', datas);
      var data = {
        seriesData: datas.seriesData,
        indicatorData: [],
        legendData: datas.legendData
      };
      console.log('this.$refs.colControl.selectCol', this.$refs.colControl.selectCol);
      console.log('this.$refs.colControl.selectCol', datas);
      this.$refs.colControl.selectCol.forEach(function (item) {
        data.indicatorData.push({
          name: codeObj[item].alias || codeObj[item].title,
          max: 150,
          unit: codeObj[item].unitName || ''
        });
      });
      console.log('data', data);
      this.$refs.charts.changeChartInit(data);
    },
    openCol: function openCol(index) {
      if (typeof index == 'number') {
        this.$refs.colControl[0].visible = true;
      } else {
        this.$refs.colControl.visible = true;
      }
    },
    moment: moment,
    searchChart: function searchChart() {
      this.initNum++;
    },
    dataTypeChange: function dataTypeChange(e) {
      this.reportType = e.target.value;

      if (e.target.value == '14') {
        this.limitSelectDate = {
          min: moment().startOf('day').subtract(1, 'month'),
          max: moment().endOf('day')
        };
        this.value[0] = this.limitSelectDate.min;
        this.value[1] = this.limitSelectDate.max;
        this.stime = this.limitSelectDate.min.format('YYYY-MM');
        this.etime = this.limitSelectDate.max.format('YYYY-MM');
      } else if (e.target.value == '11' || e.target.value == '12') {
        this.stime = this.limitSelectDate.min.format('YYYY-MM-DD');
        this.etime = this.limitSelectDate.max.format('YYYY-MM-DD');
        this.value[0] = this.limitSelectDate.min;
        this.value[1] = this.limitSelectDate.max;
      }
    },
    getWeek: function getWeek(dt) {
      var d1 = new Date(dt);
      var d2 = new Date(dt);
      d2.setMonth(0);
      d2.setDate(1);
      var rq = d1 - d2;
      var days = Math.ceil(rq / (24 * 60 * 60 * 1000));
      var num = Math.ceil(days / 7);
      return num + 1;
    },
    onWeekRangeChange: function onWeekRangeChange(value) {
      console.log('周区间', value);
      this.stime = value[0];
      this.etime = value[1];
    },
    onYearRangeChange: function onYearRangeChange(value) {
      console.log('季/年区间', value);
      this.stime = value[0] + '';
      this.etime = value[1] + '';
    },
    onallChange: function onallChange(date, dateString) {
      this.stime = dateString[0];
      this.etime = dateString[1];
      this.value = [moment(dateString[0]), moment(dateString[1])];
      console.log('实时数据/日数据', dateString);
    },
    onMonthRangeChange: function onMonthRangeChange(value) {
      this.value = value;
      this.stime = moment(value[0]).format('YYYY-MM');
      this.etime = moment(value[1]).format('YYYY-MM');
    },
    handleRangeChange: function handleRangeChange(date, dateString) {
      this.stime = dateString[0];
      this.etime = dateString[1]; // console.log('实时数据/日数据', dateString)
    }
  }
};